import { useState } from 'react';
import { Link } from 'react-router';
import { Mail, Phone, MessageCircle, Clock } from 'lucide-react';
import { APP_NAME, SUPPORT_EMAIL, SUPPORT_PHONE, WHATSAPP_NUMBER, BUSINESS_HOURS } from '@/lib/constants';

export default function ContactPage() {
  const [submitted, setSubmitted] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-border">
        <div className="mx-auto max-w-7xl flex items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
          <Link to="/" className="text-primary font-bold text-xl">{APP_NAME}</Link>
          <Link to="/" className="text-sm text-text-secondary hover:text-text transition-colors">Back to Home</Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-text">Contact Us</h1>
        <p className="mt-4 text-lg text-text-secondary">
          Have questions? We&apos;re here to help. Reach out through any of the channels below.
        </p>

        <div className="mt-10 grid gap-6 sm:grid-cols-2">
          <div className="bg-bg border border-border rounded-xl p-6">
            <Mail className="w-6 h-6 text-primary" />
            <h3 className="mt-3 font-semibold">Email</h3>
            <p className="mt-1 text-sm text-text-secondary">{SUPPORT_EMAIL}</p>
          </div>
          <div className="bg-bg border border-border rounded-xl p-6">
            <Phone className="w-6 h-6 text-primary" />
            <h3 className="mt-3 font-semibold">Phone</h3>
            <p className="mt-1 text-sm text-text-secondary">{SUPPORT_PHONE}</p>
          </div>
          <div className="bg-bg border border-border rounded-xl p-6">
            <MessageCircle className="w-6 h-6 text-primary" />
            <h3 className="mt-3 font-semibold">WhatsApp</h3>
            <p className="mt-1 text-sm text-text-secondary">{WHATSAPP_NUMBER}</p>
          </div>
          <div className="bg-bg border border-border rounded-xl p-6">
            <Clock className="w-6 h-6 text-primary" />
            <h3 className="mt-3 font-semibold">Business Hours</h3>
            <p className="mt-1 text-sm text-text-secondary">{BUSINESS_HOURS}</p>
          </div>
        </div>

        {submitted ? (
          <div className="mt-10 bg-success/10 border border-success/20 rounded-xl p-6 text-center">
            <h3 className="font-semibold text-success">Message Sent</h3>
            <p className="mt-1 text-sm text-text-secondary">Thank you for reaching out. We will get back to you soon.</p>
          </div>
        ) : (
          <form onSubmit={(e) => { e.preventDefault(); setSubmitted(true); }} className="mt-10 space-y-5">
            <div>
              <label htmlFor="name" className="block text-sm font-medium mb-1.5">Name</label>
              <input id="name" type="text" required className="w-full rounded-lg border border-border px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary" />
            </div>
            <div className="grid sm:grid-cols-2 gap-5">
              <div>
                <label htmlFor="phone" className="block text-sm font-medium mb-1.5">Phone</label>
                <input id="phone" type="tel" className="w-full rounded-lg border border-border px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary" />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium mb-1.5">Email</label>
                <input id="email" type="email" className="w-full rounded-lg border border-border px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary" />
              </div>
            </div>
            <div>
              <label htmlFor="message" className="block text-sm font-medium mb-1.5">Message</label>
              <textarea id="message" required rows={4} className="w-full rounded-lg border border-border px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary resize-y" />
            </div>
            <button type="submit" className="rounded-lg bg-primary px-6 py-3 text-sm font-semibold text-white hover:bg-primary-dark transition-colors">
              Send Message
            </button>
          </form>
        )}
      </main>

      <footer className="border-t border-border">
        <div className="mx-auto max-w-3xl px-4 py-6 text-center text-xs text-text-secondary">
          <p>&copy; {new Date().getFullYear()} {APP_NAME}. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
